import CloseIcon from '@mui/icons-material/Close';
import { Dialog, DialogContent, DialogTitle, IconButton } from '@mui/material';
import { Html5Qrcode, Html5QrcodeSupportedFormats } from 'html5-qrcode';
import { useEffect, useRef, useState } from 'react';
import './style.scss';

const Scanner = ({ onScan, onClose, isOpen }) => {
    const [scanError, setScanError] = useState(null);
    const html5QrCodeRef = useRef(null);

    useEffect(() => {
        if (isOpen) {
            const startScanner = async () => {
                try {
                    const html5QrCode = new Html5Qrcode("reader", {
                        formatsToSupport: [
                            Html5QrcodeSupportedFormats.QR_CODE,
                            Html5QrcodeSupportedFormats.AZTEC,
                            Html5QrcodeSupportedFormats.CODABAR,
                            Html5QrcodeSupportedFormats.CODE_39,
                            Html5QrcodeSupportedFormats.CODE_93,
                            Html5QrcodeSupportedFormats.CODE_128,
                            Html5QrcodeSupportedFormats.DATA_MATRIX,
                            Html5QrcodeSupportedFormats.MAXICODE,
                            Html5QrcodeSupportedFormats.ITF,
                            Html5QrcodeSupportedFormats.EAN_13,
                            Html5QrcodeSupportedFormats.EAN_8,
                            Html5QrcodeSupportedFormats.PDF_417,
                            Html5QrcodeSupportedFormats.RSS_14,
                            Html5QrcodeSupportedFormats.RSS_EXPANDED,
                            Html5QrcodeSupportedFormats.UPC_A,
                            Html5QrcodeSupportedFormats.UPC_E,
                            Html5QrcodeSupportedFormats.UPC_EAN_EXTENSION,
                        ],
                        experimentalFeatures: {
                            useBarCodeDetectorIfSupported: true
                        }
                    });
                    html5QrCodeRef.current = html5QrCode;

                    const config = {
                        fps: 10,
                        qrbox: { width: 400, height: 250 },
                        aspectRatio: 1.0,
                        videoConstraints: {
                            focusMode: "continuous",
                            height: { min: 720 },
                        }
                    };

                    await html5QrCode.start(
                        { facingMode: "environment" },
                        config,
                        (decodedText) => {
                            onScan(decodedText);
                            stopScanner();
                        },
                        (errorMessage) => {
                            console.error(`Scan failed`, errorMessage)
                        }
                    );
                } catch (err) {
                    setScanError("Failed to start scanner: " + err);
                }
            };

            // Small timeout to ensure DOM is ready
            setTimeout(startScanner, 100);
        } else {
            stopScanner();
        }

        return () => {
            stopScanner();
        };
    }, [isOpen]);

    const stopScanner = async () => {
        if (html5QrCodeRef.current) {
            try {
                if (html5QrCodeRef.current.isScanning) {
                    await html5QrCodeRef.current.stop();
                }
                html5QrCodeRef.current.clear();
            } catch (err) {
                console.error("Failed to stop scanner", err);
            }
            html5QrCodeRef.current = null;
        }
    };

    const handleClose = () => {
        stopScanner();
        onClose();
    };

    return (
        <Dialog open={isOpen} onClose={handleClose} fullWidth maxWidth="sm" className="scanner-dialog">
            <DialogTitle>
                Scan QR/Barcode
                <IconButton
                    aria-label="close"
                    onClick={handleClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent>
                <div className="scanner-container">
                    <div id="reader" width="100%"></div>
                    {scanError && <div className="error-message">{scanError}</div>}
                    <div className="scanner-overlay">
                        <div className="scanner-line"></div>
                    </div>
                </div>
            </DialogContent>
        </Dialog>
    );
};

export default Scanner;
